import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import BodyView from "@/layout/BodyView.vue";
import AuthView from "@/components/auth/AuthView.vue";
import NotFound from "@/components/auth/NotFound.vue";
import Login from "@/components/auth/Login.vue";
import Register from "@/components/auth/Register.vue";
import ForgetPassword from "@/components/auth/ResetPassword.vue";
import RequestReset from "@/components/auth/RequestReset.vue";
import Dashboard from "@/pages/IndexDashboard.vue";
import PrivateChat from "@/pages/chat/IndexPrivateChat.vue";
import GroupChat from "@/pages/chat/IndexGroupChat.vue";
import SalesDashboard from "@/pages/dashboard/SalesProduct.vue";
import ClinicDashboard from "@/pages/dashboard/SalesClinic.vue";
import WarehouseDashboard from "@/pages/dashboard/SalesProduct.vue";
import FinanceDashboard from "@/pages/dashboard/FinanceProduct.vue";
import AdminDashboard from "@/pages/dashboard/SalesAdmin.vue";


const routes: Array<RouteRecordRaw> = [
	{
		path: "",
		redirect: "/dashboard",
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'NotFound',
		component: NotFound
	},
	{
		path: "/",
		name: "home",
		component: BodyView,
		meta: {
			title: "Indoforcetech",
			middleware: ["auth"] // Add middleware for authentication check
		},
		children: [
			{
				path: "dashboard",
				name: "dashboard",
				component: Dashboard,
				meta: {
					title: "Indoforcetech",
					middleware: ["auth"] // Add middleware for authentication check
				},
			},
			{
				path: "/sales/dashboard",
				name: "sales dashboard",
				component: SalesDashboard,
				meta: {
					title: "Indoforcetech",
					middleware: ["auth"] // Add middleware for authentication check
				},
			},
			{
				path: "/admin/dashboard",
				name: "admin dashboard",
				component: AdminDashboard,
				meta: {
					title: "Indoforcetech",
					middleware: ["auth"] // Add middleware for authentication check
				},
			},
			{
				path: "/clinic/dashboard",
				name: "clinic dashboard",
				component: ClinicDashboard,
				meta: {
					title: "Indoforcetech",
					middleware: ["auth"] // Add middleware for authentication check
				},
			},
			{
				path: "/warehouse/dashboard",
				name: "warehouse dashboard",
				component: WarehouseDashboard,
				meta: {
					title: "Indoforcetech",
					middleware: ["auth"] // Add middleware for authentication check
				},
			},
			{
				path: "/finance/dashboard",
				name: "finance dashboard",
				component: FinanceDashboard,
				meta: {
					title: "Indoforcetech",
					middleware: ["auth"] // Add middleware for authentication check
				},
			},
		],
	},
	{
		path: "/auth",
		component: AuthView,
		children: [
			{
				path: "login",
				name: "login",
				component: Login,
				meta: {
					title: "Indoforcetech",
				},
			},
			{
				path: "register",
				name: "register",
				component: Register,
				meta: {
					title: "Indoforcetech",
				},
			},
			{
				path: "reset_password",
				name: "resetPassword",
				component: RequestReset,
				meta: {
					title: "Forget Password | INDOFORCETECH",
				},
			},
			{
				path: "forget_password",
				name: "forgetPassword",
				component: ForgetPassword,
				meta: {
					title: "Forget Password | INDOFORCETECH",
				},
			},
		],
	},
	{
		path: "/app",
		component: BodyView,
		children: [
			{
				path: "private_chat",
				name: "Chatapp",
				component: PrivateChat,
				meta: {
					title: "Private Chat| INDOFORCETECH",
				},
			},
			{
				path: "group_chat",
				name: "Group Chat",
				component: GroupChat,
				meta: {
					title: "Group Chat| INDOFORCETECH",
				},
			},
		],
	},
];

// Import shipping routes before using them
import * as shipping from '@/router/shipping';
routes.push(shipping.route);
import * as sales from '@/router/sales';
routes.push(sales.route);
import * as warehouse from '@/router/warehouse';
routes.push(warehouse.route);
// import * as purchase from '@/router/purchase';
// routes.push(purchase.route);
// import * as accounting from '@/router/accounting';
// routes.push(accounting.route);
import * as users from '@/router/users';
routes.push(users.route);
// import * as management from '@/router/management';
// routes.push(management.route);
import * as clinic from '@/router/clinic';
routes.push(clinic.route);
import * as setting from '@/router/setting';
routes.push(setting.route);
import * as master from '@/router/master';
routes.push(master.route);

import { checkRequest } from "@/api/services/AuthRequest";
import { useMenuStore } from "@/store/menu";

// Helper function to clear authentication-related localStorage items
const clearAuthStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");	
    localStorage.removeItem("menu-auth");
};

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes,
});

// Helper function to check if route exists in menu store
const isRouteInMenu = (path: string, menuData: any[]): boolean => {
    for (const menuItem of menuData) {
        if (menuItem.path === path) {
            return true;
        }
        if (menuItem.children) {
            if (isRouteInMenu(path, menuItem.children)) {
                return true;
            }
        }
    }
    return false;
};

router.beforeEach(async (to: any, from: any, next: any) => {

	
    // Set document title from route meta
    if (typeof to.meta.title === "string") {
        document.title = to.meta.title;
    }

    // Check if route exists in menu store (skip for auth routes and not found)
    const publicPaths = ["/auth/login", "/auth/register", "/auth/forget_password", "/auth/reset_password", "/dashboard", "/"];
    const isPublicPath = publicPaths.includes(to.path) || to.path.startsWith("/auth/") || to.name === "NotFound";
    
    if (!isPublicPath) {
        try {
            const menuStore = useMenuStore();
            const menuData = menuStore.data;
            
            if (!isRouteInMenu(to.path, menuData)) {
                return next({ name: "NotFound" });
            }
        } catch (error) {
            console.warn("Menu validation error:", error);
        }
    }

    const tokenInQuery = to.query?.token as string | undefined;
    const tokenInStorage = localStorage.getItem("token");

    const loginPath = "/auth/login";
    const registerPath = "/auth/register";
    const dashboardPath = "/"; // Or your specific main authenticated route

    // Paths that are publicly accessible for authentication processes
    const publicAuthProcessPaths = ["/auth/login", "/auth/forget_password", "/auth/reset_password"];

    if (tokenInQuery) {
        localStorage.setItem("token", tokenInQuery);
        localStorage.removeItem("user"); // User info will be re-fetched or is part of checkRequest
        localStorage.removeItem("menu-auth"); // Clear menu auth, might be tied to old state

        try {
            const resp = await checkRequest(); // Validates token and fetches initial user data
            const userNickname = resp.data.nickname; // Adjust if structure is different

            // Prepare to navigate, removing the token from URL query
            const { token, ...queryWithoutToken } = to.query;

            if (userNickname === "") {
                // Token is valid, but user profile is incomplete (no nickname)
                if (to.path !== registerPath) {
                    // If not already on the register page, redirect there
                    return next({ path: registerPath, query: {}, replace: true });
                }
                // Already on register page and nickname is empty. Allow to proceed on register page.
                // Remove token from query.
                return next({ path: registerPath, query: queryWithoutToken, replace: true });
            } else {
                // Token is valid, and user has a nickname (is fully registered)
                if (to.path.startsWith("/auth/")) {
                    // If user landed on any auth page (login, register, etc.) with a valid token & nickname,
                    // redirect them to the main application/dashboard area.
                    return next({ path: dashboardPath, query: {}, replace: true });
                }
                // User is navigating to a non-auth (protected) page with a valid token & nickname. Proceed.
                return next({ path: to.path, query: queryWithoutToken, replace: true });
            }
        } catch (error) {
            // Token validation failed (e.g., expired, invalid)
            clearAuthStorage();
            return next({ path: loginPath, query: {}, replace: true }); // Redirect to login
        }
    } else {
        // No token in query parameters, rely on token in localStorage

        if (publicAuthProcessPaths.includes(to.path)) {
            // User is explicitly navigating to login, forget password, reset password.
            clearAuthStorage(); // Clear any potentially stale session data.
            return next(); // Allow access.
        }

        if (to.path === registerPath) {
            // Allow direct access to the register page.
            // If a user with a valid token in localStorage somehow lands here,
            // the register page component itself should ideally handle redirecting them.
            return next();
        }

        // For all other routes (assumed to be protected)
        if (!tokenInStorage) {
            // No token in localStorage, and not a public auth/register path. Redirect to login.
            return next({ path: loginPath });
        }

        // Token exists in localStorage. Allow access to the protected route.
        // Consider adding a periodic validation of the stored token if session expiry is critical.
        // For now, matching original behavior: if token in storage, assume valid until explicitly handled.
        return next();
    }
});

export default router;
